import React from 'react'

export default function CodeOfConductView () {
  return (
    <div id='code-of-conduct'>
      <p>Our goal is to have a fun and welcoming celebration of roguelike games, so we have a formalized code of conduct that sets these expectations.</p>
      <p><a href='https://roguelike.club/code.html' target='_blank' rel='noreferrer'>Read our Code of Conduct.</a></p>
      <p>If you&apos;re being harassed, notice someone being harassed, or have any other concerns related to the code of conduct, you have a few options:</p>
      <ul>
        <li>Type <code>/mod</code> into the chat box, followed by a message, to contact all moderators.</li>
        <li>Email <a href="mailto:contact@roguelike.club">contact@roguelike.club</a>.</li>
        <li>If you have a report or concern related to an organizer, please contact a different member of the <a href="https://roguelike.club/who.html" target="_blank" rel="noreferrer">organizing team</a> outside of this tool (via email, Twitter DM, Discord, or some other service).</li>
      </ul>
    </div>
  )
}
